import { Component, OnDestroy, OnInit } from '@angular/core';
import { ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { HouseholdQuery, HouseholdService } from '@core/state/household';
import * as moment from 'moment';
import { Subscription } from 'rxjs';

@Component({
  selector   : 'app-monthly-cost',
  templateUrl: './monthly-cost.component.html',
  styleUrls  : ['./monthly-cost.component.scss'],
})
export class MonthlyCostComponent implements OnInit, OnDestroy {
  lineChartData: ChartDataSets[] = [
    {data: [25, 50, 75], label: 'Series A', fill: 1},
    {data: [10, 20, 30], label: 'Series B', fill: 1},
    {data: [0, 0, 0], label: 'Series C', fill: 1},
  ];
  lineChartLabels: Label[]       = ['jun', 'aug', 'sep'];
  maxValue                       = 100;
  household                      = null;
  errorMessage                   = "...";
  householdQuery$                = new Subscription();

  constructor(
    private householdService: HouseholdService,
    private householdQuery: HouseholdQuery,
  ) {

  }

  ngOnInit() {
    this.getDataFromHousehold();
  }

  ngOnDestroy(): void {
    this.householdQuery$.unsubscribe();
  }

  getDataFromHousehold() {
    this.householdQuery$.unsubscribe();
    this.householdQuery$ = this.householdQuery.select().subscribe((household: any) => {
      // if (!household.hasOwnProperty('total_cost')) {
      //   return;
      // }

      this.household     = household;
      let tc             = household.total_cost;
      let ts             = household.total_cost - household.total_saving;
      this.lineChartData = [
        {data: [tc, tc, tc, tc, tc], label: 'Bruto kosten per maand', fill: 1},
        {data: [ts, ts, ts, ts, ts], label: 'Nieuwe kosten per maand', fill: 1},
      ];

      const thisMonth   = moment().startOf("month").format('MMMM');
      const lastMonth   = moment().subtract(1, "month").startOf("month").format('MMMM');
      const last2Months = moment().subtract(2, "month").startOf("month").format('MMMM');
      const last3Months = moment().subtract(3, "month").startOf("month").format('MMMM');
      const last4Months = moment().subtract(4, "month").startOf("month").format('MMMM');

      this.lineChartLabels = [last4Months, last3Months, last2Months, lastMonth, thisMonth];
      this.maxValue        = tc + 1000;
    }, (err) => {
      console.log(err);
      this.errorMessage = err.message + ' - ' + err.error.message;
    });
  }

}
